export default __webpack_public_path__ + "static/blue-d125cb35b0d5acd2deaeb350e187a49e.png";